<template>
    <div class="notif-card hover-card" :disabled="disabled" @click="handleViewNotif">
        <div class="notif-card__header flex flex--align-center flex--justify-between">
            <div class="notif-card__header__status">{{ ndata.timestamp | formatDate('YYYY-MM-DD HH:mm') }} | {{ statusStr }}</div>
            <div class="notif-card__header__type">{{ typeStr }}</div>
        </div>
        <div class="notif-card__subject">{{ ndata.subject }}</div>
        <div class="notif-card__content">
            <div class="notif-card__content__inner">{{ ndata.content }}</div>
        </div>
        <div class="notif-card__small">发布人：{{ ndata.sender }}</div>
        <div class="notif-card__small">创建时间：{{ ndata.created_at | formatDate('YYYY-MM-DD HH:mm') }}</div>
        <div class="notif-card__footer flex flex--justify-between flex--align-center">
            <div class="notif-card__footer__icons flex flex--align-center">
                <div class="notif-card__footer__icons__icon" v-if="ndata.viaWeb">
                    <v-icon type="icondevices-24px"></v-icon>
                </div>
                <div class="notif-card__footer__icons__icon" v-if="ndata.indexNotif">
                    <v-icon type="iconpriority_high-24px"></v-icon>
                </div>
                <div class="notif-card__footer__icons__icon" v-if="ndata.viaPhone">
                    <v-icon type="iconsms-24px"></v-icon>
                </div>
                <div class="notif-card__footer__icons__icon" v-if="ndata.viaEmail">
                    <v-icon type="iconemail-24px1"></v-icon>
                </div>
                <div class="notif-card__footer__icons__icon notif-card__footer__icons__text" v-if="ndata.receiversCategory.includes('business')">商务</div>
                <div class="notif-card__footer__icons__icon notif-card__footer__icons__text" v-if="ndata.receiversCategory.includes('director')">主管</div>
                <div class="notif-card__footer__icons__icon notif-card__footer__icons__text" v-if="ndata.receiversCategory.includes('financial')">财务</div>
                <div class="notif-card__footer__icons__icon notif-card__footer__icons__text" v-if="ndata.receiversCategory.includes('customer')">客户</div>
                <div class="notif-card__footer__icons__icon notif-card__footer__icons__text" v-if="ndata.receiversUsers.length > 0" style="letter-spacing: -0.4">{{ ndata.receiversUsers.length }}{{ ndata.receiversUsers.length > 100 ? '+' : ''}}</div>
            </div>
            <div v-if="!disabled && ndata.sender_id === myUserId" class="notif-card__footer__actions flex flex--justify-between">
                <div class="notif-card__footer__actions__btn" @click.stop="handleModifyNotif">修改</div>
                <div class="notif-card__footer__actions__btn" @click.stop="handleDeleteNotif">删除</div>
            </div>
        </div>
    </div>
</template>
<script>
import { NOTIFICATION_TYPE_MAPPING, STATUS_TEXT_MAPPING } from "@/assets/staticData/NotificationMapping.js";
import { mapActions, mapState } from "vuex";

export default {
    name: 'notif-card',
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        ndata: {
            type: Object,
            default: {}
        }
    },
    computed: {
        ...mapState("user", {
            myUserId: "id"
        }),
        statusStr() {
            return STATUS_TEXT_MAPPING[this.ndata.status];
        },
        typeStr() {
            return NOTIFICATION_TYPE_MAPPING[this.ndata.type];
        }
    },
    methods: {
        ...mapActions({
            setToView: "notification/setToView",
            setToModify: "notification/setToModify",
            setToBeDeleted: "notification/setToBeDeleted",
        }),
        handleDeleteNotif() {
            this.setToBeDeleted({ notification: this.ndata });
        },
        handleViewNotif() {
            this.setToView({ notification: this.ndata });
        },
        handleModifyNotif() {
            this.setToModify({ notification: this.ndata });
        },
    }
}
</script>
<style lang="less">
    @import "../static/static.less";
    @prefix: ~'notif-card';
    .@{prefix} {
        width: 750px;
        height: 240px;
        background: white;
        border-radius: 8px;
        box-shadow: 0 0 2px 0 rgba(black, 0.1), 0 2px 2px 0 rgba(black, 0.08), 0 1px 3px 0 rgba(black, 0.16);
        padding: 8px 8px 12px 8px;
        margin-top: 8px;
        &[disabled] {
            background: #ECEFF1;

            & .@{prefix}__header {
                background: rgba(black, 0.08);
                &__status {
                    color: rgba(black, 0.26);
                }
                &__type {
                    color: rgba(black, 0.26);
                }
            }

            & .@{prefix}__subject {
                color: rgba(black, 0.26);
            }

            & .@{prefix}__content {
                color: rgba(black, 0.26);
            }

            & .@{prefix}__small {
                color: rgba(black, 0.26);
            }

            & .@{prefix}__footer {
                &__icons__icon {
                    color: rgba(black, 0.12);
                    &.text {
                        color: rgba(134, 124, 233, 0.26);
                    }
                }

                &__actions__btn:nth-child(1) {
                    color: rgba(black, 0.26);
                }
            }
        }

        &__header {
            width: 736px;
            height: 48px;
            border-radius: 8px;
            background: rgba(134, 124, 233, 0.12);
            padding: 8px 8px 8px 16px;
            margin-bottom: 8px;

            &__status {
                font-size: 14px;
                font-weight: 700;
                line-height: 32px;
                color: #51458B;
            }

            &__type {
                min-width: 72px;
                height: 32px;
                border: 1px solid rgba(black, 0.12);
                border-radius: 8px;
                padding: 4px 8px;
                text-align: center;
                vertical-align: middle;

                font-size: 14px;
                font-weight: 400;
                line-height: 24px;
                color: rgba(black, 0.54);
            }
        }

        &__subject {
            margin-left: 8px;
            margin-bottom: 4px;

            font-weight: 400;
            font-size: 12px;
            line-height: 16px;
            letter-spacing: 0.4;
            color: rgba(black, 0.87);
        }

        &__content {
            margin-left: 8px;
            margin-bottom: 12px;

            &__inner {
                width: 720px;
                height: 40px;
                text-overflow: ellipsis;
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;

                font-size: 14px;
                font-weight: 400;
                line-height: 20px;
                color: rgba(black, 0.54);
            }
        }

        &__small {
            margin-left: 8px;
            font-size: 12px;
            line-height: 16px;
            font-weight: 400;
            color: rgba(black, 0.26);
        }

        &__footer {
            margin-left: 8px;
            margin-top: 20px;
            width: 720px;
            height: 40px;

            &__icons {
                &__icon {
                    width: 40px;
                    height: 40px;
                    background: rgba(black, 0.08);
                    border-radius: 50%;
                    padding: 8px;
                    margin-right: 4px;
                }

                &__text {
                    line-height: 24px;
                    font-weight: 700;
                    font-size: 12px;
                    color: #867CE9;

                    text-align: center;
                    vertical-align: middle;
                }
            }

            &__actions {
                width: 80px;
                margin-right: 8px;
                &__btn {
                    font-size: 14px;
                    font-weight: 500;
                    color: #7C4DFF;
                    line-height: 20px;

                    &:hover {
                        cursor: pointer;
                    }
                }
            }
        }
    }
</style>